//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "@banno/jha-wc/src/jha-nav/jha-nav";
import "@banno/jha-wc/src/icons/jha-icon-people";
import "@banno/jha-wc/src/icons/jha-icon-transfer-filled";
import "@banno/jha-wc/src/icons/jha-icon-template";
import "@banno/jha-wc/src/icons/jha-icon-circle-user";
import "@banno/jha-wc/src/icons/jha-icon-folder";
import "@banno/jha-wc/src/icons/jha-icon-reports";
import "@banno/jha-wc/src/icons/jha-icon-download";
import "@banno/jha-wc/src/icons/jha-icon-globe";
import "@banno/jha-wc/src/icons/jha-icon-business";
import "@banno/jha-wc/src/jha-avatar/jha-avatar";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-toggle/jha-dropdown-toggle";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu/jha-dropdown-menu";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu-item/jha-dropdown-menu-item";
import "@banno/jha-wc/src/dropdowns/jha-dropdown/jha-dropdown";
import Router from "@jack-henry/web-component-router";
import { routerConfig } from "../../routers";
import { removeAllCookies } from "../../utils/removeAllCookies";
import Cookies from "js-cookie";
import { decryptValue, stringComparison } from "../../utils/app-utils";
import { GlobalConstants, GlobalVariables } from "../../utils/constants";
import { AppRouters } from "../../utils/app-router";
import { isFeatureEnabled } from "../../utils/launchdarkly-helpers";
import { FeatureFlags } from "../../utils/launchdarkly-config";
import { launchDarkly } from "../../utils/launchdarkly-service";
import { jhaDropdownMenuPanelStyles } from "../../styles/jha-dropdown-menu-panel";
import { REPORT_EXPORT_SCREEN_LABEL } from "../../constants/report-export-screen-label";

@customElement("side-nav")
export class SideNavBar extends LitElement {
  static get is() {
    return "side-nav";
  }
  static readonly styles = [jhaDropdownMenuPanelStyles, css`
    #sideBarDiv {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 107px;
      background-color: var(--jh-platform-content-main-background-color, var(--jh-color-container-page));
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19),
        inset -1px 0 0 0 #dddddd;
    }
    #logoDiv {
      display: flex;
      justify-content: center;
    }
    img {
      padding: 16px;
      height: 48px;
      width: 48px;
    }
    #navIconDiv {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      text-align: center;
      transform: translateX(-4px);
    }
    #navDiv {
      display: flex;
      flex-direction: column;
      padding: 20px;
      align-items: center;
    }
    #navIcon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    #longName {
      margin: 0;
    }
    .disabledTab {
      pointer-events: none;
      opacity: 0.4;
      cursor: default;
    }
    a {
      height: 72px;
      padding-top: 3rem;
      padding-bottom: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    a:hover {
      background-color: #dbe8fb;
    }
    a:active {
      background-color: #dbe8fb;
    }
    p {
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      margin: 0;
    }
    jha-dropdown-menu {
      display: flex;
      flex-direction: column;
      left: 3vw;
    }
    /* Avatar menu: compact row (avoid prior 5vh stretching Logout vertically). */
    #avatarDiv jha-dropdown-menu-item {
      display: flex;
      align-items: center;
    }
    jha-dropdown-menu-item[data-auto-id="logoutBtn"] span {
      font-weight: 600;
      font-size: 14px;
      transform: translateY(-1px);
    }
    #avatarDiv {
      margin-bottom: 0.5rem;
      display: flex;
      justify-content: center;
      width: 100%;
      transform: translateX(2px);
    }
    #userInfoDiv {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 1rem;
      padding: 0 4px;
      text-align: center;
      transform: translateX(-4px);
    }
    #userInfoDiv .username {
      font-size: 10px;
      font-weight: 400;
      color: #c9c9c9;
      line-height: 1.2;
      margin: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    #userInfoDiv .userType {
      font-size: 9px;
      font-weight: 600;
      color: #9a9a9a;
      line-height: 1.2;
      margin: 2px 0 0 0;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
    #userInfoDiv .businessUnit {
      font-size: 9px;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 1.2;
      margin: 2px 0 0 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
    #tabDisable {
      pointer-events: none;
      opacity: 0.4;
      cursor: default;
    }
    jha-icon-people,
    jha-icon-transfer-filled,
    jha-icon-template,
    jha-icon-reports,
    jha-icon-download,
    jha-icon-globe,
    jha-icon-business {
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `];

  onChangePasswordClick() {
    const router = new Router(routerConfig);
    router.go("/users/change-password");
  }

  onLogoutClick() {
    removeAllCookies();
    sessionStorage.removeItem("callbackTokenFetched");
    // Hard navigation: main-element.login is only set in connectedCallback.
    // Soft router.go leaves the logged-in shell visible until F5.
    window.location.assign("/login");
  }

  @property()
  activeTab = "users";
  @property()
  loggedUserType = decryptValue(Cookies.get("userType") || "");
  @property()
  loggedUserEmail = decryptValue(Cookies.get("email") || "");
  @property()
  loggedUserBu = Cookies.get("businessUnit") || "";

  private getUserTypeAbbreviation(userType: string): string {
    const normalized = (userType || "").toLowerCase().replace(/\s+/g, "");
    switch (normalized) {
      case "enterpriseadmin":
        return "EA";
      case "businessadmin":
      case "businessunitadmin":
        return "BUA";
      case "enterpriseuser":
        return "EU";
      case "businessuser":
      case "businessunituser":
        return "BU";
      default:
        return userType
          ? userType
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase())
            .join("")
          : "";
    }
  }
  @property({ type: Boolean })
  isJHADomain = false;

  // LaunchDarkly feature flag for showing templates
  @state()
  showBusinessUnits = false;
  @state()
  showIpAllowList = false;
  @state()
  showTemplates = false;
  /** Verified JHID picture URL (empty until preload succeeds). */
  @state()
  profilePictureUrl = "";

  private resolveProfilePicture(): void {
    const url = (Cookies.get("picture") || "").trim();
    if (!url) {
      this.profilePictureUrl = "";
      return;
    }
    const img = new Image();
    img.onload = () => {
      this.profilePictureUrl = url;
    };
    img.onerror = () => {
      this.profilePictureUrl = "";
    };
    img.src = url;
  }

  // Pull current flag values from LD and push them into Lit state. Used
  // both on mount and after LD's async initialization resolves; the .on()
  // change listeners alone are insufficient because LD does not emit a
  // change event for the initial value.
  //
  // Defaults are intentionally `false` (fail closed). Product rule: a feature
  // is hidden unless LaunchDarkly explicitly turns it on. Do NOT change these
  // to `true` to "preserve visibility" if LD fails — the local-dev bug that
  // motivated `whenReady()` was that flags were never re-read after async
  // init, not that the defaults were wrong. `whenReady()` is guaranteed to
  // resolve even if LD initialization rejects, so this function runs on both
  // success and failure paths and overwrites these defaults with the real LD
  // values whenever the client is reachable.
  private refreshFlagValues = (): void => {
    this.showTemplates = isFeatureEnabled(FeatureFlags.SHOW_TEMPLATES, false);
    this.showBusinessUnits = isFeatureEnabled(FeatureFlags.SHOW_BUSINESS_UNITS, false);
    this.showIpAllowList = isFeatureEnabled(FeatureFlags.SHOW_IP_ALLOW_LIST, false);
  };

  private handleShowTemplatesChange = (newValue: boolean, oldValue: boolean) => {
    console.log(`LaunchDarkly: SHOW_TEMPLATES flag changed from ${oldValue} to ${newValue}`);
    console.log(`Previous showTemplates value: ${this.showTemplates}`);

    // Store old value before updating
    const previousValue = this.showTemplates;

    // Update the value
    this.showTemplates = newValue;

    console.log(`New showTemplates value: ${this.showTemplates}`);

    // Explicitly notify Lit of the property change (more reliable than just requestUpdate)
    this.requestUpdate("showTemplates", previousValue);

    console.log("UI re-render requested - Templates menu should now", newValue ? "APPEAR" : "DISAPPEAR");
  };

  // Handler for LaunchDarkly flag changes (store reference for cleanup)
  private handleShowBusinessUnitsChange = (newValue: boolean, oldValue: boolean) => {
    console.log(`LaunchDarkly: SHOW_BUSINESS_UNITS flag changed from ${oldValue} to ${newValue}`);
    console.log(`Previous showBusinessUnits value: ${this.showBusinessUnits}`);

    // Store old value before updating
    const previousValue = this.showBusinessUnits;

    // Update the value
    this.showBusinessUnits = newValue;

    console.log(`New showBusinessUnits value: ${this.showBusinessUnits}`);

    // Explicitly notify Lit of the property change (more reliable than just requestUpdate)
    this.requestUpdate("showBusinessUnits", previousValue);

    console.log("UI re-render requested - Business Units menu should now", newValue ? "APPEAR" : "DISAPPEAR");
  };

  private handleShowIpAllowListChange = (newValue: boolean, oldValue: boolean) => {
    console.log(`LaunchDarkly: SHOW_IP_ALLOW_LIST flag changed from ${oldValue} to ${newValue}`);
    console.log(`Previous showIpAllowList value: ${this.showIpAllowList}`);

    // Store old value before updating
    const previousValue = this.showIpAllowList;

    // Update the value
    this.showIpAllowList = newValue;

    console.log(`New showIpAllowList value: ${this.showIpAllowList}`);

    // Explicitly notify Lit of the property change (more reliable than just requestUpdate)
    this.requestUpdate("showIpAllowList", previousValue);

    console.log("UI re-render requested - IP Allow List menu should now", newValue ? "APPEAR" : "DISAPPEAR");
  };

  private resolveActiveTabFromPath(pathName: string): string {
    const path = pathName || "";
    if (path.includes("/users")) return "users";
    if (path.includes("/workflow-templates")) return "workflow-templates";
    if (path.includes("/workflows")) return "workflows";
    if (path.includes("/audit-reporting") || path.includes("/reporting")) return "reporting";
    if (path.includes("/audit-export") || path.includes("/export")) return "export";
    if (path.includes("/business-units") || path.includes("/institutions")) return "business-units";
    if (path.includes("/ip-whitelist")) return "ip";
    return "";
  }

  private syncActiveTabFromCurrentPath = (): void => {
    const tab = this.resolveActiveTabFromPath(AppRouters?.page?.current ?? "");
    if (tab) this.activeTab = tab;
  };

  connectedCallback(): void {
    super.connectedCallback();

    this.resolveProfilePicture();

    // Read current flag values on mount. LD's `change:` events only fire on
    // *subsequent* value changes, so subscriptions alone miss the initial
    // state and the menus stay hidden until something toggles in LD.
    this.refreshFlagValues();

    // LD initialization is async (kicked off by MainElement). If we mounted
    // before it completed, re-read once it's ready so the menus reflect the
    // real flag values without requiring a flag change to wake them up.
    launchDarkly.whenReady().then(() => this.refreshFlagValues());

    console.log("showTemplates", this.showTemplates);
    console.log("showBusinessUnits", this.showBusinessUnits);
    console.log("showIpAllowList", this.showIpAllowList);

    // Subscribe to real-time flag changes
    launchDarkly.on(FeatureFlags.SHOW_TEMPLATES, this.handleShowTemplatesChange);
    launchDarkly.on(FeatureFlags.SHOW_BUSINESS_UNITS, this.handleShowBusinessUnitsChange);
    launchDarkly.on(FeatureFlags.SHOW_IP_ALLOW_LIST, this.handleShowIpAllowListChange);

    this.syncActiveTabFromCurrentPath();

    if (typeof AppRouters?.addRouteChangeCompleteCallback === "function") {
      AppRouters.addRouteChangeCompleteCallback(this.syncActiveTabFromCurrentPath);
    }

    if (this.loggedUserEmail) {
      this.isJHADomain = GlobalConstants.JHADOMAIN.includes(this.loggedUserEmail.split("@")[1]?.toLowerCase());
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    // IMPORTANT: Clean up LaunchDarkly event listener to prevent memory leaks
    launchDarkly.off(FeatureFlags.SHOW_TEMPLATES, this.handleShowTemplatesChange);
    launchDarkly.off(FeatureFlags.SHOW_BUSINESS_UNITS, this.handleShowBusinessUnitsChange);
    launchDarkly.off(FeatureFlags.SHOW_IP_ALLOW_LIST, this.handleShowIpAllowListChange);
    if (typeof AppRouters?.removeRouteChangeCompleteCallback === "function") {
      AppRouters.removeRouteChangeCompleteCallback(this.syncActiveTabFromCurrentPath);
    }
    console.log("LaunchDarkly: Unsubscribed from SHOW_TEMPLATES flag changes");
    console.log("LaunchDarkly: Unsubscribed from SHOW_BUSINESS_UNITS flag changes");
    console.log("LaunchDarkly: Unsubscribed from SHOW_IP_ALLOW_LIST flag changes");
  }

  render() {
    return html`
      <div id="sideBarDiv">
        <div id="logoDiv">
          <img src="/jha-logo.png" alt="JHA" />
        </div>
        <jha-nav>
          <a
            ?active=${stringComparison(this.activeTab, "users")}
            href="/users"
            data-auto-id="usersLink"
            @click=${() => (this.activeTab = "users")}>
            <div id="navIconDiv">
              <div id="navIcon"><jha-icon-people></jha-icon-people></div>
              <p>Users</p>
            </div>
          </a>
          <a
            ?active=${stringComparison(this.activeTab, "workflows")}
            href="/workflows"
            data-auto-id="workflowLink"
            @click=${() => (this.activeTab = "workflows")}>
            <div id="navIconDiv">
              <div id="navIcon">
                <jha-icon-transfer-filled></jha-icon-transfer-filled>
              </div>
              <p>Workflows</p>
            </div>
          </a>
          ${this.showTemplates
        ? html`
                <a
                  ?active=${stringComparison(this.activeTab, "workflow-templates")}
                  href="/workflow-templates"
                  data-auto-id="workflowTemplateLink"
                  @click=${() => (this.activeTab = "workflow-templates")}>
                  <div id="navIconDiv">
                    <div id="navIcon"><jha-icon-template></jha-icon-template></div>
                    <p id="longName">Workflow</p>
                    <p id="longName">Templates</p>
                  </div>
                </a>
              `
        : html``}
          ${this.showBusinessUnits
        ? html`
                <a
                  ?active=${stringComparison(this.activeTab, "business-units")}
                  href="/business-units"
                  data-auto-id="businessUnitLink"
                  @click=${() => (this.activeTab = "business-units")}>
                  <div id="navIconDiv">
                    <div id="navIcon"><jha-icon-globe></jha-icon-globe></div>
                    <p id="longName">Business</p>
                    <p id="longName">Units</p>
                  </div>
                </a>
              `
        : html``}
          ${this.showIpAllowList
        ? html` <a
                ?active=${stringComparison(this.activeTab, "ip")}
                href="/ip-whitelist"
                data-auto-id="ipWhitelistLink"
                id="tabDisable"
                @click=${() => (this.activeTab = "ip")}>
                <div id="navIconDiv">
                  <div id="navIcon"><jha-icon-business></jha-icon-business></div>
                  <p id="longName">IP Allow</p>
                  <p id="longName">List</p>
                </div>
              </a>`
        : html``}
          <a
            ?active=${stringComparison(this.activeTab, "reporting")}
            href="/audit-reporting"
            data-auto-id="auditReportLink"
            @click=${() => (this.activeTab = "reporting")}>
            <div id="navIconDiv">
              <div id="navIcon"><jha-icon-reports></jha-icon-reports></div>
              <p>Reporting</p>
            </div>
          </a>
          <a
            ?active=${stringComparison(this.activeTab, "export")}
            href="/audit-export"
            data-auto-id="auditExportLink"
            @click=${() => (this.activeTab = "export")}>
            <div id="navIconDiv">
              <div id="navIcon"><jha-icon-download></jha-icon-download></div>
              <p id="longName">${REPORT_EXPORT_SCREEN_LABEL}</p>
            </div>
          </a>
        </jha-nav>
        <div style="flex:1;"></div>

				<jha-tooltip bottom-right text="Click and select logout">
					<div id="avatarDiv">
						<jha-dropdown>
							<jha-dropdown-toggle data-auto-id="avatarDropdown" slot="toggle" tabindex="0" aria-expanded="false" aria-haspopup="true" role="button">
								${this.profilePictureUrl
        ? html`<jha-avatar .avatar=${this.profilePictureUrl} style="background-color: #9999;"></jha-avatar>`
        : html`<jha-avatar initials=${decryptValue(Cookies.get("userId") as string)?.charAt(0) || ""} style="background-color: #9999;"></jha-avatar>`}
							</jha-dropdown-toggle>
							<jha-dropdown-menu open-up role="menu" aria-label="Account">
								<jha-dropdown-menu-item data-auto-id="logoutBtn" role="menuitem" @click=${this.onLogoutClick}>
									<span>Logout</span>
								</jha-dropdown-menu-item>
							</jha-dropdown-menu>
						</jha-dropdown>
					</div>
				</jha-tooltip>
				<div id="userInfoDiv">
					<p class="username" title=${decryptValue(Cookies.get("userId") as string) || ""}>${decryptValue(Cookies.get("userId") as string) || ""}</p>
					<p class="userType" title=${this.loggedUserType || ""}>${this.getUserTypeAbbreviation(this.loggedUserType)}</p>
					${this.loggedUserBu && !/enterpriseadmin/i.test(this.loggedUserType || "")
        ? html`<p class="businessUnit" title=${this.loggedUserBu}>${this.loggedUserBu}</p>`
        : html``}
				</div>
			</div>
		`;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "side-nav": SideNavBar;
  }
}
